import React from "react";
import { FaWhatsapp, FaArrowRight, FaShieldAlt } from "react-icons/fa";
import { SITE_CONTENT } from "../content";

const FinalCtaSection = () => {
  const { title, description, primaryButton, secondaryButton } =
    SITE_CONTENT.pages.homePage.finalCta;

  const scrollToBooking = (e) => {
    e.preventDefault();
    const el = document.getElementById("booking-section");
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="bg-[#051109] text-white py-24 lg:py-32 relative overflow-hidden text-center" id="final-cta">
      {/* Background Ambience */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-[#0f2e1a] rounded-full blur-[160px] opacity-40 pointer-events-none" />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-10 relative z-10">
        
        {/* Brand Crest */}
        <div className="flex items-center justify-center mb-8">
          <div className="p-1 rounded-full bg-gradient-to-tr from-[#D4AF37] to-[#E8A040] shadow-2xl shadow-amber-500/20">
            <img
              src={SITE_CONTENT.global.logoImage}
              alt="Nawabi Caterers"
              className="w-20 h-20 object-contain rounded-full bg-white p-1"
            />
          </div>
        </div>

        {/* Halal Certified & Assurance */}
        <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#14532d]/80 border border-[#22c55e]/40 text-[#22c55e] text-xs font-bold tracking-widest uppercase mb-6 shadow">
          <FaShieldAlt />
          100% Halal Outdoor Catering · NonVeeFoods Family
        </div>

        {/* Headline */}
        <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-light font-serif text-[#f8f4ee] leading-tight mb-6">
          {title}
        </h2>

        {/* Description */}
        <p className="text-[#c8d4cc] text-base sm:text-lg md:text-xl font-light leading-relaxed mb-12 max-w-2xl mx-auto">
          {description}
        </p>

        {/* Dual Action CTAs - Single Row on Mobile & Desktop */}
        <div className="flex flex-row items-center justify-center gap-2 sm:gap-4 mb-10 max-w-xl mx-auto">
          <a
            href="#booking-section"
            onClick={scrollToBooking}
            className="flex-1 sm:flex-initial inline-flex items-center justify-center gap-1.5 sm:gap-3 px-3 sm:px-8 py-2.5 sm:py-4 bg-gradient-to-r from-[#D4AF37] via-[#E8A040] to-[#F5C070] text-[#0a1a0f] font-bold text-[10px] xs:text-[11px] sm:text-xs tracking-normal sm:tracking-[0.15em] uppercase rounded-full shadow-[0_0_30px_rgba(232,160,64,0.35)] hover:scale-105 transition-all duration-300 group text-center shrink-0 min-w-0 whitespace-nowrap"
          >
            <span className="hidden sm:inline">{primaryButton.label}</span>
            <span className="sm:hidden">Request Quote</span>
            <FaArrowRight className="w-2.5 h-2.5 sm:w-3.5 sm:h-3.5 transition-transform group-hover:translate-x-1 shrink-0" />
          </a>

          <a
            href={secondaryButton.whatsappUrl}
            target="_blank"
            rel="noreferrer"
            className="flex-1 sm:flex-initial inline-flex items-center justify-center gap-1.5 sm:gap-3 px-3 sm:px-8 py-2.5 sm:py-4 bg-[#0d2a17]/90 hover:bg-[#143e23] border border-[#22c55e]/50 text-white font-semibold text-[10px] xs:text-[11px] sm:text-xs tracking-normal sm:tracking-[0.12em] uppercase rounded-full transition-all duration-300 hover:scale-105 shadow-lg group text-center shrink-0 min-w-0 whitespace-nowrap"
          >
            <FaWhatsapp className="text-[#25D366] w-3.5 h-3.5 sm:w-5 sm:h-5 transition-transform group-hover:scale-110 shrink-0" />
            <span className="hidden md:inline">{secondaryButton.label}</span>
            <span className="md:hidden">Call / WhatsApp</span>
          </a>
        </div>

        {/* Direct Call Quick Link */}
        <div className="flex items-center justify-center gap-2 text-sm text-[#a4b4a9]">
          <span>Direct Helpline:</span>
          <a href="tel:+919150299336" className="text-[#E8A040] font-bold hover:underline">
            +91 91502 99336
          </a>
          <span className="text-white/40">·</span>
          <a href="mailto:nawabicaterers.support@gmail.com" className="text-white/80 hover:text-white hover:underline">
            nawabicaterers.support@gmail.com
          </a>
        </div>

      </div>
    </section>
  );
};

export default FinalCtaSection;
